import { render, staticRenderFns } from "./ChartFooter.vue?vue&type=template&id=b9b912c4&scoped=true&"
import script from "./ChartFooter.vue?vue&type=script&lang=ts&"
export * from "./ChartFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ChartFooter.vue?vue&type=style&index=0&id=b9b912c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b912c4",
  null
  
)

export default component.exports